import React from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor } from '../../modules/store';
import ErrorBoundary from './ErrorBoundary';

const Wrapper = ({ children }) => (
  <ErrorBoundary>
    <Provider store={window.store}>
      <PersistGate loading={null} persistor={persistor}>
        {children}
      </PersistGate>
    </Provider>
  </ErrorBoundary>
);

export default Wrapper;
